import React from 'react';
import styles from './card.module.css';
import CardTitle from '../../../../lib/component/cardTitle/cardTitle';
import CardItem from './cardItem/cardItem';
import { CategoryItem } from '../../js/interface';
import statisticsApi from '../../../../lib/statisticsApi';

export default ({ title, arr }: { title: string; arr: CategoryItem[] }) => {
  const arrrr = [
    '小说',
    '经管',
    '生活',
    '社科',
    '工具',

    '玄幻小说',
    '武侠仙侠',
    '都市生活',
    '军事历史',
    '科幻世界',
    '官场职场',
    '网游竞技',
    '悬疑惊悚',

    '古代言情',
    '穿越架空',
    '青春校园',
    '总裁豪门',
    '幻想奇缘',
    '耽美同人',
    '现代言情',
  ];
  const arrr = [120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139];

  function ck(title: string) {
    for (let i = 0; i < arrrr.length; i++) {
      if (title === arrrr[i]) {
        statisticsApi.statisticsApi(arrr[i]);
      }
    }
  }

  return (
    <>
      <div className={styles.card}>
        <CardTitle {...{ title: title, tip: '', fn: () => {} }}></CardTitle>
        <div className={styles.cardContent}>
          {arr.map((item, index) => {
            return (
              <CardItem
                {...{
                  srcArr: item.illustrations,
                  title: item.title,
                  number: item.number,
                  ck: ck,
                }}
                key={index}
              ></CardItem>
            );
          })}
        </div>
      </div>
    </>
  );
};
